import axios from "axios";
import { trim } from "lodash";
import React, { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Loader from "../Components/Global/Loader";
import { MenuAll } from "../Components/Layout/MenuAll";
import useAxiosFetch from "../hooks/useAxiosFetch";
const AuthContext = React.createContext([]);
export function useAuth() {
  return useContext(AuthContext);
}

export function AuthProvider({ children }) {
  const navigate = useNavigate();
  const pathname = useLocation();
  const [loading, setLoading] = useState(true);
  const [customloadingAuth, setcustomLoadingAuth] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [userInfo, setUserInfo] = useState();
  const [loginSuccessmsg, setLoginSuccessmsg] = useState();
  const [token, setToken] = useState();
  const [designation, setDesignation] = useState("");
  const [activeBar, setActivebar] = useState();
  const [sidebar, setSidebar] = useState([]);
  const [allStateList, setallStateList] = useState([]);
  const [unitCount, setUnitCount] = useState();
  const [buildingCount, setBuildingCount] = useState();
  const [userRole, setUserRole] = useState();
  // api api from global hook 

  const { axiosFetch} = useAxiosFetch();
  const [userDetails, setUserDetails] = useState({});
  let makeURL = pathname.pathname + (pathname.search ? pathname.search : "");
  let rmaDeveloperList = MenuAll().RMA_developer;
  let ownerlist = MenuAll().Owner_sidebarList;
  let Partnerlist = MenuAll().Partner_sidebarList;
  let managerlist = MenuAll().Manager_sidebarList;
  let Accountant = MenuAll().Accountant_sidebarList;

  useEffect(() => {
    HandelRefresh();
    if (makeURL == "/dashboard" || makeURL == "/tenantdashboard") {
      localStorage.removeItem("sidebarActive");
      setActivebar();
    }
  }, []);

  function Logout() {
    axios.get("/logout").then((response) => {
      if (response.status == 200) {
        setIsAuthenticated(false);
        HandelRefresh();
        const activebar = localStorage.removeItem("sidebarActive");
        setActivebar(activebar);
        navigate("/");
        return true;
      }
    });
  }

  function HandelRefresh() {
    setLoading(true);
    axios
      .get("/verify")
      .then((response) => {
        if (response.status == 200) {
          setIsAuthenticated(true);
          setToken(response.data.verify_token);
        }
        setLoading(false);
      })
      .catch((e) => {
        setLoading(false);
      });
  }

  useEffect(() => {
    setLoading(true);
    setcustomLoadingAuth(true);
    if (isAuthenticated) {
      // UserDetails()
      axiosFetch({
        axiosInstance: axios,
        method: "GET",
        url: "/userDetails",
      })
        .then((response) => {
          setLoading(false);
          setUserDetails(response.data?.UserDetails);
          setDesignation(response?.data?.UserDetails?.Designation);
          setUserRole(response?.data?.UserDetails?.Designation);
          if (response?.data) {
            const Landingpage = response?.data?.UserDetails?.Designation;
            if (Landingpage == "Owner" || Landingpage == "Partner") {
              if (trim(makeURL) !== "/" && makeURL) {
                navigate(makeURL);
              } else {
                navigate("/dashboard");
              }
            } else if (Landingpage == "Manager") {
              if (trim(makeURL) !== "/" && makeURL) {
                navigate(makeURL);
              } else {
                navigate("/managerdashboard");
              }
            } else if (Landingpage == "Admin") {
              if (trim(makeURL) !== "/" && makeURL) {
                navigate(makeURL);
              } else {
                navigate("/admindashboard");
              }
            } else if (Landingpage == "Accountant") {
              if (trim(makeURL) !== "/" && makeURL) {
                navigate(makeURL);
              } else {
                navigate("/accountantdashboard");
              }
            } else if (Landingpage == "Tenant") {
              if (trim(makeURL) !== "/" && makeURL) {
                navigate(makeURL);
              } else {
                navigate("/tenantdashboard");
              }
            } else {
              if (trim(makeURL) !== "/" && makeURL) {
                navigate(makeURL);
              } else {
                navigate("/workerdashboard");
              }
            }
            setcustomLoadingAuth(false);
          }
        })
        .catch((e) => {
          setLoading(false);
          setcustomLoadingAuth(false);
        });
    }
  }, [isAuthenticated]);

  useEffect(() => {
    if (designation == "Owner") {
      setSidebar(ownerlist);
    } else if (designation == "Manager") {
      setSidebar(managerlist);
    } else if (designation == "Partner") {
      setSidebar(Partnerlist);
    } else if (designation == "Accountant") {
      setSidebar(Accountant);
    } else if (designation == "Admin") {
      setSidebar(rmaDeveloperList);
    } else {
      setSidebar([]);
    }
  }, [designation]);

  const value = {
    loading,
    setLoading,
    isAuthenticated,
    setIsAuthenticated,
    userInfo,
    setUserInfo,
    token,
    setToken,
    Logout,
    loginSuccessmsg,
    setLoginSuccessmsg,
    sidebar,
    designation,
    unitCount,
    setUnitCount,
    buildingCount,
    setBuildingCount,
    activeBar,
    setActivebar,
    userRole,
    setUserRole,
    customloadingAuth,
    setcustomLoadingAuth,
    userDetails,
    setallStateList,
    allStateList,
    setUserDetails,
  };
  return (
    <AuthContext.Provider value={value}>
      {loading ? <Loader /> : children}
    </AuthContext.Provider>
  );
}
